import React from 'react';
import { Field, getIn, useFormikContext } from 'formik';
import { Row, Col } from 'react-bootstrap';
import { FormikInput, FormikDatePicker } from '../../../components';

/* ------------------------------------------------------------------ */
/* Layout for Open questions: Text, Email, Numeric, Date                */
/* ------------------------------------------------------------------ */
export const OpenQuestionsLayout = ({ valuePath, responseFormat }) => {
  const { errors, touched } = useFormikContext();

  const getPreviewProps = () => {
    switch (responseFormat) {
      case 'email':
        return { type: 'email', placeholder: 'ejemplo@ejemplo.com' };
      case 'date':
        return { type: 'date', placeholder: 'dd/mm/aaaa' };
      case 'numeric':
        return { type: 'number', placeholder: 'Escriba numero(s)' };
      case 'text':
        return { as: 'textarea', rows: 3, placeholder: 'Ingrese su respuesta aquí' };
      default:
        return { type: 'text', placeholder: 'Ingrese respuesta' };
    }
  };

  const previewProps = getPreviewProps();

  return (
    <div className="mt-3">
      {/* Pregunta */}
      <Row>
        <Col md={10}>
          <Field name={`${valuePath}[label]`}>
            {({ field }) => (
              <FormikInput
                {...field}
                abbr
                label="Pregunta"
                maxLength={100}
                tooltipText="Máximo 100 caracteres"
                error={getIn(errors, field.name)}
                touched={getIn(touched, field.name)}
              />
            )}
          </Field>
        </Col>
      </Row>

      {/* Descripción opcional */}
      <Row>
        <Col md={6}>
          <Field name={`${valuePath}[description]`}>
            {({ field }) => (
              <FormikInput
                {...field}
                label="Descripción opcional"
                maxLength={300}
                placeholder="Escriba una descripción"
                tooltipText="Máximo 300 caracteres"
                error={getIn(errors, field.name)}
                touched={getIn(touched, field.name)}
              />
            )}
          </Field>
        </Col>
      </Row>

      {/* Vista previa de la respuesta */}
      <Row className="mt-2">
        <Col md={6} style={responseFormat === 'date' ? { zIndex: 2 } : undefined}>
          <div className="d-flex align-items-center">
            <div style={{ flex: 1 }}>
              {responseFormat === 'date' ? (
                <FormikDatePicker name="preview" label="Respuesta:" placeholder="dd/mm/aaaa" disabled />
              ) : (
                <FormikInput {...previewProps} name="preview" label="Respuesta:" disabled />
              )}
            </div>
            <span className="ms-3 text-muted" style={{ fontSize: '13px', marginLeft: '12px' }}>
              (Vista Previa)
            </span>
          </div>
        </Col>
      </Row>
    </div>
  );
};

export default OpenQuestionsLayout;
